import * as React from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { styled } from "@mui/material/styles";
interface CheckboxProps {
    options: any;
    rest?: any;
    style?: React.CSSProperties;
    onChange?:any;
    checked?:boolean;
}

const StyledFormControlLabel = styled(FormControlLabel)({
    '& .muiltr-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-checked':{
        color: '#7B0E6E'
    }
    })
    
function CustomCheckbox({ options,onChange,checked, style }: CheckboxProps) {
    const [checkedItems, setCheckedItems] = React.useState<string[]>([]);

  

    return (
        <FormGroup>
          {  options.map((item:any)=>{
                return(
               <>
                <StyledFormControlLabel control={
                <Checkbox
                 defaultChecked={item?.defaultChecked} 
                 onChange={onChange}
                 checked={checked}

                />} 
                label={item.label}
                 style={style} />
                </>
                )
            })
           
        }
        </FormGroup>
    )
}

export default CustomCheckbox